<script lang="ts" setup>
	import { reactor } from '~/utils/functions'

	defineProps<{
		show: boolean
		discount?: number
		couponText?: string
	}>()
	const { name } = useRoute()
	const emit = defineEmits<{
		(arg: 'update:show', param: boolean): void
	}>()

	const referralId = computed(() => {
		const { User } = reactor(useUser())
		return User.value?.referral_id || ''
	})

	const copyClipboard = () => {
		if (!referralId.value) {
			return useNotification().alert({
				status: 400,
				message: 'Referral Id Not available'
			})
		}
		const accountLink = `${location.protocol}//${location.host}/register?referrer=${referralId.value}`
		navigator.clipboard.writeText(accountLink)
		resolve(() =>
			useMixpanel().track('share-referral-link', {
				business_name: useUser().User?.customer?.name ?? '',
				email: useUser().User?.email ?? ''
			})
		)
		useNotification().alert({
			status: 200,
			message: 'Referral code copied successfully!'
		})
	}
	const navigateToRewardHistory = () => {
		navigateTo({
			path: '/rewards',
			query: {
				modal: ''
			}
		})
		emit('update:show', false)
	}
</script>

<template>
	<dialogs
		:show="show"
		@change="
			() => {
				emit('update:show', false)
			}
		"
	>
		<div class="flex flex-col items-center justify-center">
			<lazy-tools-icon dir="other" icon="gift" class="mb-10" />

			<div>
				<div class="">
					<div class="mx-auto mb-10 flex flex-col items-center justify-center">
						<h2 class="mb-5 text-center text-xl font-[700] text-blue-950 md:text-[24px]">Refer and earn</h2>

						<p class="max-w-[380px] text-center font-medium text-gray-500">
							Invite a friend and earn when they purchase their first plan.
						</p>
					</div>

					<div
						class="mx-auto flex w-full max-w-[500px] flex-col items-center justify-center rounded-lg bg-gray-100 py-5"
					>
						<h3 class="text-center text-lg font-bold capitalize text-blue-950 md:text-xl">
							{{ referralId }}
						</h3>

						<p
							class="mt-6 max-w-[312px] text-center text-sm italic leading-snug tracking-wider text-gray-500"
						>
							Hello, I use MyCoverGenius for my business insurance coverage. Sign up to get covered.
						</p>
					</div>
				</div>

				<div class="flex flex-col items-center space-y-3">
					<button
						type="button"
						class="my-8 flex flex-col items-center justify-center gap-3"
						@click="copyClipboard"
					>
						<div class="cursor-pointer rounded-full bg-[#E6F4F2] p-3.5">
							<lazy-tools-icon dir="other" icon="link" />
						</div>
						<p class="text-sm font-medium leading-[20px] text-[#4FBFA3]">Copy link</p>
					</button>

					<button
						v-if="name !== 'rewards'"
						class="inline-flex items-center gap-x-3 font-medium text-gray-600 transition hover:text-primary-2"
						@click="navigateToRewardHistory"
					>
						<span>Referrals</span>
						<span class="">
							<lazy-tools-icon dir="arrows" icon="caret-right" path-class="stroke-primary-2 " />
						</span>
					</button>
				</div>
			</div>
		</div>
	</dialogs>
</template>
